
import pic1 from '../../Assets/Clients/02.jpg';
import pic2 from '../../Assets/Clients/03.jpg';
import pic3 from '../../Assets/Clients/04.jpg';
import pic4 from '../../Assets/Clients/05.jpg';
import pic5 from '../../Assets/Clients/06.jpg';

export const ClientsData = [
    {
        name: 'Linda Smith',
        text: 'My experience with Prime Asset Flow has been a very positive one. The level of knowledge, professionalism and customer care are unmatched',
        img: pic1
    },
    {
        name: 'Sam Deen',
        text: 'Prime Asset Flow has constantly demonstrated excellence in every aspect in their role as my investment advisors and in their relationship with me as their client',
        img: pic2
    },
    {
        name: 'Dennis Eaton',
        text: 'Prime Asset Flow is literally the best investment site out there, I\'m a witness of that',
        img: pic3
    },
    {
        name: 'Kimberly Garcia',
        text: 'This company keeps helping evey investor earn more Bitcoin for themselves',
        img: pic5
    },
    {
        name: 'Dan Urwin',
        text: "I've been investing with this platform for three months now, and I would say I'ts recommendable to every investor who choses to invest from any country",
        img: pic4
    }
]